import React from 'react';
import { team } from '../data/team';

const FoundersSection = () => {
  return (
    <section id="team" className="founders-section">
      <div className="founders-container">
        <div className="founders-header">
          <h2 className="founders-title">Meet the Makers</h2>
          <p className="founders-subtitle">
            NFT-People is made by an artist and a developer who met on Tezos. Here's the tiny team behind the pixels.
          </p>
        </div>

        <div className="founders-grid">
          {team.map((member) => (
            <article
              key={member.name}
              className="founder-card"
            >
              <div className="founder-header">
                <div className="founder-avatar">
                  {member.avatar ? (
                    <img
                      src={member.avatar}
                      alt={`${member.name} avatar`}
                      className="avatar-image"
                    />
                  ) : (
                    <div className="avatar-fallback">
                      {member.name
                        .split(" ")
                        .map((s) => s[0])
                        .join("")
                        .slice(0, 2)}
                    </div>
                  )}
                </div>
                <div className="founder-info">
                  <h3 className="founder-name">{member.name}</h3>
                  <p className="founder-role">{member.role}</p>
                </div>
              </div>

              <p className="founder-bio">{member.bio}</p>

              <div className="founder-links">
                {member.links?.x && (
                  <a
                    href={member.links.x}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${member.name} on X (Twitter)`}
                    className="founder-link founder-link--x"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                    </svg>
                  </a>
                )}
                {member.links?.linkedin && (
                  <a
                    href={member.links.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${member.name} on LinkedIn`}
                    className="founder-link founder-link--linkedin"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </a>
                )}
                {member.links?.objkt && (
                  <a
                    href={member.links.objkt}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${member.name} on Objkt`}
                    className="founder-link founder-link--objkt"
                  >
                    🎨
                  </a>
                )}
                {member.links?.website && (
                  <a
                    href={member.links.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${member.name} website`}
                    className="founder-link founder-link--website"
                  >
                    🌐
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FoundersSection;

